export default () => {
  // --------------------
  // 変数の定義
  // 枠で囲う変数
  var initiaWrap = '<div class="initialGroup"></div>',
    facultyInitial;

// 教員の絞り込みで使う変数
// var facultyVal,
// 	$facultyBox = $('.js-faculty-box'),
// 	facultyUrl = 'http://www.nucba.ac.jp/research/faculty/',
// 	facultyHash = location.hash,
// 	facultyLocation = location.href;


// --------------------
// 教員の絞り込み
// 教員の絞り込み実行
// initialSwitch();

// 絞り込み内容でプルダウンを選択
// $('.js-pageNavSelect').val(facultyHash);


  // --------------------
  // 枠で囲う処理
  // イニシャルを .initialGroup で囲う
  $('.js-initialA').wrapAll(initiaWrap);
  $('.js-initialB').wrapAll(initiaWrap);
  $('.js-initialC').wrapAll(initiaWrap);
  $('.js-initialD').wrapAll(initiaWrap);
  $('.js-initialE').wrapAll(initiaWrap);
  $('.js-initialF').wrapAll(initiaWrap);
  $('.js-initialG').wrapAll(initiaWrap);
  $('.js-initialH').wrapAll(initiaWrap);
  $('.js-initialI').wrapAll(initiaWrap);
  $('.js-initialJ').wrapAll(initiaWrap);
  $('.js-initialK').wrapAll(initiaWrap);
  $('.js-initialL').wrapAll(initiaWrap);
  $('.js-initialM').wrapAll(initiaWrap);
  $('.js-initialN').wrapAll(initiaWrap);
  $('.js-initialO').wrapAll(initiaWrap);
  $('.js-initialP').wrapAll(initiaWrap);
  $('.js-initialQ').wrapAll(initiaWrap);
  $('.js-initialR').wrapAll(initiaWrap);
  $('.js-initialS').wrapAll(initiaWrap);
  $('.js-initialT').wrapAll(initiaWrap);
  $('.js-initialU').wrapAll(initiaWrap);
  $('.js-initialV').wrapAll(initiaWrap);
  $('.js-initialW').wrapAll(initiaWrap);
  $('.js-initialX').wrapAll(initiaWrap);
  $('.js-initialY').wrapAll(initiaWrap);
  $('.js-initialZ').wrapAll(initiaWrap);

  // .initialGroupを個別に処理
  $('.initialGroup').each(function () {
    // 見出しの挿入
    facultyInitial = $(this).children('.js-faculty-box:first').attr('data-initial');
    $(this).prepend('<p class="initialBorder"><span class="initialLink"><a id="initial' + facultyInitial + '"></a>' + facultyInitial + '</span></p>');
    // .js-faculty-boxを2件に1回 .facultyUnitで囲う
    // while($(this).children('.js-faculty-box').length){
    // 	$(this).children('.js-faculty-box:lt(2)').wrapAll('<div class="facultyUnit clearfix"></div>')
    // }
  });

  //ソート
  //initialGroup要素を取得して並び替え
  if (document.querySelector('.initialGroup')) {
    var $elements = $('.js-faculty-sort > .initialGroup').sort(function (a, b) {
      var aa = $(a).children('.js-faculty-box:first').attr('data-initial');
      var bb = $(b).children('.js-faculty-box:first').attr('data-initial');
      //昇順ソート。不等号を逆にすることで降順にできる。
      if (aa > bb) {
        return 1;
      } else if (aa < bb) {
        return -1;
      }
      return 0;
    });

    //js-faculty-sort内を全て削除
    $('.js-faculty-sort').empty();

    //並び替えた順にliを追加する
    $elements.each(function () {
      $('.js-faculty-sort').append($(this));
    });
  }

  // --------------------
  // 絞り込み
  const listItem = '.js-search-faculty-target'; // 絞り込み対象のアイテム
  const activeClass = 'isActive'; // 選択中のグループに付与されるclass名
  const searchItemInitial = '.js-search-faculty-item'; // 絞り込み項目1
  const searchItemUnit = '.js-search-faculty-item2'; // 絞り込み項目2

  /**
   * リストの絞り込みを行う
   */
  function search_filter(searchItem, searchItemClass, dataName, hideClass) {
    const initialGroup = document.querySelectorAll('.initialGroup');

    // 非表示状態を解除
    $(listItem).removeClass(hideClass);
    [].forEach.call(initialGroup, (group) => {
      group.style.display = 'flex';
    });

    // 全て表示
    if (searchItem.hasClass(activeClass) === true) {
      searchItem.removeClass(activeClass);
      return;
    }

    // activeClassをリセット
    $(searchItemClass).removeClass(activeClass);

    // activeClassをつける
    searchItem.addClass(activeClass);

    const searchItemData = searchItem.data(dataName);

    // リスト内の各アイテムをチェック
    for (let i = 0; i < $(listItem).length; i++) {
      // アイテムに設定している項目を取得
      let itemData = $(listItem).eq(i).data(dataName);
      // 絞り込み対象かどうかを調べる
      console.log(itemData);
      if ( itemData.match(`${searchItemData}`) ) {
        /* 何もしない */
      } else {
        $(listItem).eq(i).addClass(hideClass);
      }
    }
  }

  /**
   * 空のグループを削除
   */
  const emptyBlockRemove = () => {
    const initialGroup = document.querySelectorAll('.initialGroup');
    [].forEach.call(initialGroup, (group) => {
      const box = group.querySelectorAll('.js-faculty-box');
      let count = 0;
      [].forEach.call(box, (item) => {
        if (item.classList.contains('searchFacultyisHide') || item.classList.contains('searchFacultyisHide2')) {
          count++;
        }
      });
      if (count === box.length) {
        group.style.display = 'none';
      }
    });
  };

  /**
   * 領域のdisable対応
   */
  const filterNarrowDown = () => {
    const affiliations = document.querySelectorAll(searchItemUnit);
    [].forEach.call(affiliations, (item) => {
      // item.classList.add('disabled');
      const affiliation = item.getAttribute('data-affiliation');
      const findAffiliation = document.querySelectorAll(`.js-search-faculty-target[data-affiliation*=${affiliation}]:not(.searchFacultyisHide):not(.searchFacultyisHide2)`);
      // if (findAffiliation.length > 0) {
      //   item.classList.remove('disabled');
      // }
    })
  };

  /**
   * 絞り込みを変更した時
   */
  // イニシャル
  $(searchItemInitial).on('click', function () {
    search_filter($(this), searchItemInitial, 'initial', 'searchFacultyisHide');
    emptyBlockRemove();
    filterNarrowDown();
  });

  // 領域
  $(searchItemUnit).on('click', function () {
    search_filter($(this), searchItemUnit, 'affiliation', 'searchFacultyisHide2');
    emptyBlockRemove();
    filterNarrowDown();
  });

  /**
   * 存在しないイニシャルのフィルターを削除
   */
  const filterInitials = document.querySelectorAll(searchItemInitial);
  [].forEach.call(filterInitials, (item) => {
    const initial = item.getAttribute('data-initial');
    const findInitial = document.querySelectorAll(`.js-initial${initial}`);
    if (findInitial.length === 0) {
      item.remove();
    }
  });

  /**
   * 存在しない領域のフィルターを削除
   */
  const affiliations = document.querySelectorAll(searchItemUnit);
  [].forEach.call(affiliations, (item) => {
    const affiliation = item.getAttribute('data-affiliation');
    const findAffiliation = document.querySelectorAll(`.js-search-faculty-target[data-affiliation*=${affiliation}]`);
    if (findAffiliation.length === 0) {
      item.remove();
    }
  });

// --------------------
// プルダウンで絞り込む
// $('.js-pageNavSelect').change(function() {
// 	facultyVal = $(this).val();
// 	if ( -1 !== facultyLocation.indexOf("=") ){
// 		location.href = facultyUrl + facultyVal;
// 	} else {
// 		location.href = facultyUrl + facultyVal;
// 		location.reload();
// 	}
// });
// --------------------
// クリックで絞り込む
// $('.js-selectGraduateUndergraduate').click(function() {
// 	facultyVal = $(this).attr('href');
// 	if ( -1 !== facultyLocation.indexOf("=") ){
// 		location.href = facultyUrl + facultyVal;
// 	} else {
// 		location.href = facultyUrl + facultyVal;
// 		location.reload();
// 	}
// });

// 教員の絞り込み条件
// function initialSwitch(){
// 	switch (facultyHash){
// 	case '#pUniEconomic':
// 		$facultyBox.not('.js-pUniEconomic').remove();
// 		facultyScroll();
// 		break;
// 	case '#pUniManagement':
// 		$facultyBox.not('.js-pUniManagement').remove();
// 		facultyScroll();
// 		break;

// 	case '#pUniTrade':
// 		$facultyBox.not('.js-pUniTrade').remove();
// 		facultyScroll();
// 		break;
// 	case '#pUniCommuni':
// 		$facultyBox.not('.js-pUniCommuni').remove();
// 		facultyScroll();
// 		break;
// 	case '#pGradManagement':
// 		$facultyBox.not('.js-pGradManagement').remove();
// 		facultyScroll();
// 		break;
// 	case '#pGradFinance':
// 		$facultyBox.not('.js-pGradFinance').remove();
// 		facultyScroll();
// 		break;
// 	case '#undergraduate':
// 		$facultyBox.not('.js-pUni').remove();
// 		facultyScroll();
// 		break;
// 	case '#graduate':
// 		$facultyBox.not('.js-Grad').remove();
// 		facultyScroll();
// 		break;
// 	default:
// 		$facultyBox.show();
// 		break;
// 	}
// }

// 教員のコンテンツまでスクロール
// function facultyScroll(){
// 	var $facultyContent = $('.js-facultyContent'),
// 			facultyScrollOffset = $facultyContent.offset();
// 	if($facultyContent.length) {
// 		$('html,body').animate({ scrollTop: facultyScrollOffset.top - 80 }, 'fast');
// 	}
// }
}